/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */

let siteKey;

function getRecaptchaElements() {
  return document.querySelectorAll('[data-captchaguid]');
}

function initReCaptchaV3() {
  main();
}

function setUpFormMutationObserver() {
  // listens for when the form is reloaded (kentico loads the form with new hashes after submission)
  // removes recaptcha token from field on form reload
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        if (mutation.addedNodes.length > 0) {
          let formHasRecaptchaEnterprise;
          mutation.addedNodes.forEach((node) => {
            try {
              node.childNodes.forEach((childNode) => {
                const recaptchaEnterpriseField = childNode.querySelector(
                  '.js-recaptcha-enterprise-field'
                );
                if (recaptchaEnterpriseField) {
                  recaptchaEnterpriseField.innerText = '';
                  formHasRecaptchaEnterprise = true;
                }
              });
            } catch (e) {
              // do nothing
            }
          });

          if (formHasRecaptchaEnterprise) {
            getFormOnSubmitFunction();
            removeFormOnSubmitFunction();
          }
        }
      }
    });
  });

  const config = { attributes: true, childList: true, subtree: true };
  observer.observe(document.querySelector('main'), config);
}

function onClick(form, event, submitFunction, recaptchaElement) {
  event.preventDefault();
  const isErrorShown = recaptchaElement.nextSibling?.classList?.contains('input-error-message');
  if (isErrorShown) {
    recaptchaElement.nextSibling.remove();
  }
  if (!recaptchaElement || recaptchaElement.value !== '') {
    return;
  }

  siteKey = form.querySelector('[data-captcha-key]').getAttribute('data-captcha-key');

  window.grecaptcha.enterprise.ready(() => {
    window.grecaptcha.enterprise.execute(siteKey, { action: 'submit' }).then((token) => {
      // eslint-disable-next-line no-param-reassign
      // recaptchaElement.value = token;
      const validationRequest = {
        Token: token,
        Action: 'submit'
      };

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append(
        'RequestVerificationToken',
        document.getElementsByName('__RequestVerificationToken')[0].value
      );
      fetch('/api/recaptcha/verify', {
        method: 'POST',
        headers,
        body: JSON.stringify(validationRequest),
        contentType: 'application/json'
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // eslint-disable-next-line no-param-reassign
            recaptchaElement.value = token;
            submitFunction(event);
            // eslint-disable-next-line no-param-reassign
            recaptchaElement.value = '';
          } else {
            // eslint-disable-next-line no-console
            const newErrorElement = document.createElement('span');
            newErrorElement.classList.add('input-error-message');
            newErrorElement.innerHTML = 'Recaptcha validation failed';
            recaptchaElement.insertAdjacentElement('afterend', newErrorElement);

            console.error('Recaptcha validation failed');
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    });
  });
}

function getFormOnSubmitFunction() {
  const reCaptchaElements = getRecaptchaElements();

  reCaptchaElements.forEach((recaptchaElement) => {
    const parentForm = recaptchaElement.closest('form');
    const onSubmitFunction = parentForm.getAttribute('onsubmit');

    const submitFunctionArray = onSubmitFunction
      .replace('window.', '')
      .replace(';', '')
      .replace('(event)', '')
      .split('.');
    let submitFunction = window;

    submitFunctionArray.forEach((string) => {
      submitFunction = submitFunction[string];
    });

    parentForm.setAttribute('onsubmit', '');
    parentForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      onClick(parentForm, e, submitFunction, recaptchaElement);
    });

    // override submit function to prevent form submission via .submit() from
    // spam bots
    parentForm.submit = () => {};
  });
}

function hideRecaptchaField(recaptchaElement) {
  recaptchaElement.closest('.form-group').querySelector('.label').classList.add('hidden');
}

function removeFormOnSubmitFunction() {
  const reCaptchElaements = getRecaptchaElements();

  reCaptchElaements.forEach((recaptchaElement) => {
    const parentForm = recaptchaElement.closest('form');
    hideRecaptchaField(recaptchaElement);
    parentForm.setAttribute('onsubmit', '');
  });
}

function main() {
  window.addEventListener('load', () => {
    getFormOnSubmitFunction();
    removeFormOnSubmitFunction();
    setUpFormMutationObserver();
  });
}

initReCaptchaV3();
